import type { FaireProductEntity } from "../../entity_types/product";

export const p_xnpzp926rj: FaireProductEntity = {
  token: "p_xnpzp926rj",
  type: "product",
  name: "LONG SLEEVE HIGH NECK TRENCH JACKET",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/f3fce45aec854cde6ccd1424ced7bf4edfcc81a3778412eb040aba4004f708f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f3e276b2b23167ad17d3d017fda51bd5d557a633e17a719cee7aa517b3a9489d.jpeg",
    "https://cdn.faire.com/fastly/de2b2281711d8a4dca7b49d2338a06ee23f397a5bc22ae9893a2122940eb4ad0.jpeg",
    "https://cdn.faire.com/fastly/b0cf3781b0c9a08bb3183383c567710cbab2cb69b1b5ac2ba5aebc7b03b4396b.jpeg",
    "https://cdn.faire.com/fastly/40666c930fd37527ba4a121dbebfd85062117a3bc52b234fcb39b429afdd956f.jpeg",
    "https://cdn.faire.com/fastly/f7d14048b9a4491fbd1661ab23cf05d60e7a4bbfe1940797d64727ef0510a13e.jpeg",
    "https://cdn.faire.com/fastly/723abd78e0191ba2695afe429453e860885cf98652f15dbd61607e93910d08a2.jpeg",
    "https://cdn.faire.com/fastly/d4d285a1516e7fc790ed87b7fa0b421e86ccc58c7f0cd01b99dd623d963f7180.jpeg",
  ],
  priceDollars: 282,
  description:
    'MODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32B\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 564,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:19.929Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
